/* eslint-disable react/prop-types */
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { ADMIN_DASHBOARD_PATH } from "../../router/Admin/AdminRoutes";
import { INSTITUTION_ADMIN_DASHBOARD_PATH } from "../../router/Institution/InstitutionRoutes";
import { useStateContext } from "../../context/ContextProvider";

const PageHeading = ({
  title = "",
  description = "",
  subtitle1 = "",
  subtitle1Link = "",
  subtitle2 = "",
  subtitle2Link = "",
  homeLink = "", // if provided, this takes precedence
  extra = null, // right-side actions (buttons, etc.)
  className = "", // optional custom wrapper classes
}) => {
  const { user } = useStateContext();

  // Normalize role safely
  const role = String(user?.role?.name || "")
    .trim()
    .toLowerCase();
  const isAdmin = role === "administrator";
  const isInstAdmin = role === "institution administrator";

  // Decide the home/dashboard path
  const dashboardPath =
    homeLink ||
    (isAdmin
      ? ADMIN_DASHBOARD_PATH
      : isInstAdmin
      ? INSTITUTION_ADMIN_DASHBOARD_PATH
      : "/");

  // Build breadcrumbs (Home > subtitle1 > subtitle2)
  const breadcrumbItems = [
    {
      title: (
        <Link to={dashboardPath} className="flex items-center gap-1">
          <HomeOutlined /> <span className="truncate">Home</span>
        </Link>
      ),
    },
  ];

  if (subtitle1) {
    breadcrumbItems.push({
      title: subtitle1Link ? (
        <Link
          to={subtitle1Link}
          className="text-blue-600 truncate"
          title={subtitle1}
        >
          {subtitle1}
        </Link>
      ) : (
        <span className="truncate" title={subtitle1}>
          {subtitle1}
        </span>
      ),
    });
  }

  if (subtitle2) {
    breadcrumbItems.push({
      title: subtitle2Link ? (
        <Link
          to={subtitle2Link}
          className="text-blue-600 truncate"
          title={subtitle2}
        >
          {subtitle2}
        </Link>
      ) : (
        <span className="truncate" title={subtitle2}>
          {subtitle2}
        </span>
      ),
    });
  }

  return (
    <div className={`bg-white border-b border-gray-200 px-6 py-4 ${className}`}>
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0">
          <Breadcrumb items={breadcrumbItems} />
          {title ? (
            <>
              <h1
                className="mt-2 text-xl md:text-2xl font-semibold text-gray-900 truncate"
                title={title}
              >
                {title}
              </h1>
              {description ? (
                <p className="mt-1 text-sm text-gray-600 max-w-3xl">
                  {description}
                </p>
              ) : null}
            </>
          ) : null}
        </div>

        {extra ? <div className="flex-shrink-0">{extra}</div> : null}
      </div>
    </div>
  );
};

export default PageHeading;
